import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

export const getReferredUsersLoadingState = (state: RootState): RootState['introducer']['referredUsers']['loading'] =>
  state.introducer.referredUsers.loading

export const referredUsersIsLoading = createSelector(
  getReferredUsersLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getReferredUsersData = (state: RootState): RootState['introducer']['referredUsers']['data'] =>
  state.introducer.referredUsers.data
export const getReferredUsersError = (state: RootState): RootState['introducer']['referredUsers']['error'] =>
  state.introducer.referredUsers.error

export const getUsersForReassignLoadingState = (state: RootState): RootState['introducer']['users']['loading'] =>
  state.introducer.users.loading

export const usersForReassignIsLoading = createSelector(
  getUsersForReassignLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getUsersForReassignData = (state: RootState): RootState['introducer']['users']['data'] =>
  state.introducer.users.data

export const getUsersForSearchInput = createSelector(
  (state: RootState): RootState['introducer']['users']['data'] => state.introducer.users.data,
  (users) => users.map((user) => ({ label: `${user.name} ${user.id}`, value: `${user.name} ${user.id}` })),
)

export const getUsersForReassignError = (state: RootState): RootState['introducer']['users']['error'] =>
  state.introducer.users.error

export const getAssignableReferralsLoadingState = (
  state: RootState,
): RootState['introducer']['assignableReferrals']['loading'] => state.introducer.assignableReferrals.loading

export const assignableReferralsIsLoading = createSelector(
  getAssignableReferralsLoadingState,
  (state): boolean => state === LoadingStateEnum.LOADING,
)

export const getAssignableReferralsData = (state: RootState): RootState['introducer']['assignableReferrals']['data'] =>
  state.introducer.assignableReferrals.data

export const getAssignableReferralsError = (
  state: RootState,
): RootState['introducer']['assignableReferrals']['error'] => state.introducer.assignableReferrals.error

export const introducerCanUpdateUserDetails = (state: RootState): RootState['introducer']['canUpdate'] =>
  state.introducer.canUpdate
